// extracted by mini-css-extract-plugin
export default {"container":"CG-z","innerContainer":"DG-z","multipleLines":"EG-z","heading":"FG-z","content":"GG-z","linkColor":"HG-z"};